import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const NoneNoti = memo(props => {
	const classes = useStyles();

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootImages }}>
				<Grid style={{ textAlign: "center" }}>
					<img
						src={Images.logoNonNoti}
						alt="logoNonNoti"
						className={classes.image}
					/>
					<Grid classes={{ root: classes.text }}>
						Hiện chưa có thông báo
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
});

export default NoneNoti;
